import React from 'react';
import PropTypes from 'prop-types';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';
import '../Reports.scss';
import { CsvToIntArray } from '../../../helpers/strings';

export class BaselineTaskListFilters extends React.Component {

    constructor(props, context) {
        super(props, context);

        const initialFormSelections = {
            baselineIds: '',
            departmentIds: '',
            disciplineIds: ''
        }

        this.state = {
            emptyForm: initialFormSelections,
            baselineIds: initialFormSelections.baselineIds,
            departmentIds: initialFormSelections.departmentIds,
            disciplineIds: initialFormSelections.disciplineIds
        }
    }

    componentDidMount = async () => {
        /**
         * Must set defaults before registering report filter functions, because
         * these defaults might be overridden by mapToForm values coming from
         * the API when opening a scheduled report.
         */
        this.setDefaults();
        /**
         * On mount, register all of this form's callbacks so the parent is able
         * to use them when its wrapping UI indicates these actions should be
         * performed.
         */
        this.props.registerReportFilterFunctions(
            this.props.report.id,
            this.clearForm,
            this.validateForm,
            this.mapToForm,
            this.mapToApiRequest
        );
    }

    setDefaults = () => {
        let newState = {...this.state};

        const appState = this.props.savedFilterValues;
        if (appState) {
            // Set new state to values from redux app state
            newState = {
                ...newState,
                baselineIds: appState.baselineIds ? appState.baselineIds : newState.baselineIds,
                departmentIds: appState.departmentIds ? appState.departmentIds : newState.departmentIds,
                disciplineIds: appState.disciplineIds ? appState.disciplineIds : newState.disciplineIds
            }
        }

        // Possibly override app state values with default values or URL params
        let baselineIds = this.getDefaultBaselineIds(newState.baselineIds);

        newState = {
            ...newState,
            baselineIds: baselineIds
        }

        this.setState({
            ...this.state,
            ...newState
        });
    }

    getDefaultBaselineIds = (savedBaselineIds) => {
        let baselineIds = '';
        const urlBaselineId = this.props.urlParams.baselineId;
        if (urlBaselineId && urlBaselineId.trim().length > 0) {
            baselineIds = urlBaselineId;
        } else if (savedBaselineIds) {
            baselineIds = savedBaselineIds;
        }

        return baselineIds;
    }

    clearForm = () => {
        this.setState({
            ...this.state,
            ...this.state.emptyForm
        });
    }

    validateForm = () => {
        if (!this.state.baselineIds || this.state.baselineIds.trim().length <= 0) {
            return false;
        }

        return true;
    }

    mapToForm = (reportRequest) => {
        const form = { ...this.state.emptyForm };
        
        form.baselineIds = (reportRequest.baselineIds) ? reportRequest.baselineIds.join(',') : form.baselineIds;
        form.departmentIds = (reportRequest.departmentIds) ? reportRequest.departmentIds.join(',') : form.departmentIds;
        form.disciplineIds = (reportRequest.disciplineIds) ? reportRequest.disciplineIds.join(',') : form.disciplineIds;

        this.setState({
            ...this.state,
            ...form
        });
    }

    mapToApiRequest = () => {

        const request = {
            reportId: this.props.report.id,
            
            baselineIds: CsvToIntArray(this.state.baselineIds),
            departmentIds: CsvToIntArray(this.state.departmentIds),
            disciplineIds: CsvToIntArray(this.state.disciplineIds)
        };

        return {
            apiRequest: request,
            formValues: this.state
        };
    }

    onDropdownChange = (value, name) => {
        this.onFieldChange(name, value);
    }

    onFieldChange = (name, value) => {
        this.setState({
            ...this.state,
            [name]: value
        });
    }

    render() {
        return (
            <form id="subForm" noValidate className={this.props.isFormValid ? "" : "was-validated"}>
                <div className="row">
                    <div className="col-sm-12 col-md-4">
                        <MultiSelectBox name="baselineIds"
                            label="Baseline" idField="id" valueField="name"
                            options={this.props.filters.baselines}
                            selectedValues={this.state.baselineIds.toString()}
                            onChange={this.onDropdownChange}
                            isRequired={true}
                            errorMessage="Baseline is required"
                            isMulti={true} />
                    </div>
                    <div className="col-sm-12 col-md-4">
                        <MultiSelectBox name="departmentIds"
                            label="Department" idField="id" valueField="name"
                            options={this.props.filters.departments}
                            selectedValues={this.state.departmentIds.toString()}
                            onChange={this.onDropdownChange}
                            isRequired={false}
                            isMulti={true} />
                    </div>
                    <div className="col-sm-12 col-md-4">
                        <MultiSelectBox name="disciplineIds"
                            label="Discipline" idField="id" valueField="name"
                            options={this.props.filters.disciplines}
                            selectedValues={this.state.disciplineIds.toString()}
                            onChange={this.onDropdownChange}
                            isRequired={false}
                            isMulti={true} />
                    </div>
                </div>
            </form>
        );
    }
}

BaselineTaskListFilters.propTypes = {
    report: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    urlParams: PropTypes.object.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    registerReportFilterFunctions: PropTypes.func.isRequired,
    savedFilterValues: PropTypes.object.isRequired
};

export default BaselineTaskListFilters;
